import { render, staticRenderFns } from "./NewsAnnouncements.vue?vue&type=template&id=321f35ad"
import script from "./NewsAnnouncements.vue?vue&type=script&lang=js"
export * from "./NewsAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./NewsAnnouncements.vue?vue&type=style&index=0&id=321f35ad&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderTemplate: require('/var/www/malayan/web/components/global/templates/HeaderTemplate.vue').default,NewsCardTemplate: require('/var/www/malayan/web/components/global/templates/NewsCardTemplate.vue').default,ButtonTemplate: require('/var/www/malayan/web/components/global/templates/ButtonTemplate.vue').default})
